<p class="mb-2 text-center font-base text-base font-bold">
  {{ 'parameters.for-when' | translate }}
</p>
@if (displayAsapForLaterPicker) {
  <div class="mb-2">
    <app-custom-switch-atom
      [items]="parameters"
      [type]="'light'"
      [selectedValue]="selectedWantedAtType ?? ''"
      (switchItem)="onTypeChanged($event)"
    ></app-custom-switch-atom>
  </div>
}
@if (wantedAtType === parametersWantedAtTypeValues.Later) {
  <div class="mb-2">
    @if (displayedDateSlots && displayedDateSlots.length > 1) {
      <app-custom-select-atom
        [items]="displayedDateSlots"
        [selectedItem]="selectedWantedAtDate"
        (selectItem)="onDateChanged($event)"
      ></app-custom-select-atom>
    }
    @if (!displayedDateSlots) {
      <div
        class="flex h-10 w-full animate-pulse items-center justify-start rounded rounded-full bg-neutral-100"
      >
        <img
          src="../../../../../assets/images/spinner.svg"
          class="pl-4"
        />
      </div>
    }
  </div>
  <div class="mb-6">
    @if (!timeSlotNotAvailable && (!displayedTimeSlots || displayedTimeSlots.length > 0)) {
      <div>
        @if (displayedTimeSlots) {
          <app-custom-select-atom
            [items]="displayedTimeSlots"
            (selectItem)="onTimeChanged($event)"
            [isDisable]="timeSlotNotAvailable"
            [selectedItem]="
              timeSlotNotAvailable
                ? ('parameters.wantedAt.no-slot' | translate)
                : selectedWantedAtTime
            "
          ></app-custom-select-atom>
        } @else {
          <div
            class="flex h-10 w-full animate-pulse items-center justify-start rounded rounded-full bg-neutral-100"
          >
            <img
              src="../../../../../assets/images/spinner.svg"
              class="pl-4"
            />
          </div>
        }
      </div>
    } @else {
      <div
        class="mt-1 block w-full rounded-full bg-neutral-100 py-2.5 pl-4 font-base text-base font-normal"
      >
        {{ 'parameters.wantedAt.no-slot' | translate }}
      </div>
    }
  </div>
}
